import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { XCircle } from "react-feather";
import { CartTitle, ECommerce } from "../../../../constants";
import { dynamicImage } from "../../../../utils";
import QuantityField from "./QuantityField";
import Actions from "./Actions";
import EmptyState from "./EmptyState";
import { Href, Symbol } from "../../../../constants";
import { CartTableHead } from "../../../../data/applications/ECommerce";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { Image } from "../../../../coreComponents/Image";
import { removeCartData } from "../../../../reduxToolkit/reducers/eCommerce/cartSlice";

// This component displays the cart page with the list of products.
const CartContainer = () => {
  const dispatch = useAppDispatch();
  const { cart } = useAppSelector((state) => state.cartData);
  return (
    <>
      <Breadcrumbs mainTitle={CartTitle} parent={ECommerce} />
      <Container fluid>
        <Col sm="12">
          <Card>
            <CommonCardHeader title={CartTitle} />
            <CardBody>
              {cart && cart.length > 0 ? (
              <Row>
                <div className="order-history custom-scrollbar table-responsive wishlist">
                  <Table className="table-bordered">
                    <thead>
                      <tr>
                        {/* Mapping through CartTableHead to dynamically render table headings */}
                        {CartTableHead.map((items, i) => (<th key={i}>{items}</th>))}
                      </tr>
                    </thead>
                    <tbody>
                      {cart.map((item, index) => (
                        <tr key={index}>
                          <td><Image className="img-fluid img-40" src={dynamicImage(`${item.image}`)} /></td>
                          <td><div className="product-name"><a href={Href}>{item.name}</a></div></td>
                          <td>{Symbol}{item.price}</td>
                          <QuantityField item={item} />
                          <td><Link to={Href} onClick={() => dispatch(removeCartData(item.id))}><XCircle /></Link></td>
                          <td>{Symbol}{item.price * item.total}</td>
                        </tr>
                      ))}
                      <Actions />
                    </tbody>
                  </Table>
                </div>
              </Row>
              ) : (
                <EmptyState />
              )}
            </CardBody>
          </Card>
        </Col>
      </Container>
    </>
  );
};

export default CartContainer;